import { VIDEO_MUTE, createToolbarEvent, sendAnalytics } from '../analytics';
import { setAudioOnly } from '../base/audio-only';
import { VIDEO_MUTISM_AUTHORITY, setVideoMuted } from '../base/media';

import {
    ACTION_TOGGLE_ETHERPAD,
    ACTION_TOGGLE_WHITE_BOARD,
    FLOAT_TOOLBOX_HIDDEN,
    OPEN_WHITE_BOARD,
    OPEN_WHITE_BOARD_FINAL,
    TOGGLE_ETHERPAD
} from './actionTypes';

/**
 * Signals a request to display overflow as drawer.
 *
 * @param {boolean} bool - True to display overflow as drawer, false to preserve original behaviour.
 * @returns {{
 *     type: SET_OVERFLOW_DRAWER,
 *     displayAsDrawer: boolean
 * }}
 */
export function toogleEtherPad(bool: boolean) {
    return {
        type: TOGGLE_ETHERPAD,
        bool
    };
}


/**
 * Dispatches an action to show or hide Etherpad.
 *
 * @param {string} open - Whether or not a document is currently being.
 * @returns {{
*    type: OPEN_WHITE_BOARD,
*    open: boolean
* }}
*/
export function openWhiteBoardFunction(open) {
    return {
        type: OPEN_WHITE_BOARD,
        open
    };
}

/**
 * Dispatches an action to show or hide Etherpad.
 *
 * @param {string} open - Whether or not a document is currently being.
 * @returns {{
*    type: OPEN_WHITE_BOARD_FINAL,
*    open: boolean
* }}
*/
export function openWhiteBoardFinal(open) {
    return {
        type: OPEN_WHITE_BOARD_FINAL,
        open
    };
}

/**
 * Signals a request to display overflow as drawer.
 *
 * @param {boolean} bool - True to display overflow as drawer, false to preserve original behaviour.
 * @returns {{
*     type: ACTION_TOGGLE_ETHERPAD,
*     bool: boolean
* }}
*/
export function actionToggleEtherPad(bool) {
    return {
        type: ACTION_TOGGLE_ETHERPAD,
        bool
    };
}

/**
 * Signals a request to display overflow as drawer.
 *
 * @param {boolean} bool - True to display overflow as drawer, false to preserve original behaviour.
 * @returns {{
*     type: ACTION_TOGGLE_WHITE_BOARD,
*     bool: boolean
* }}
*/
export function actionToggleWhiteBoard(bool) {
    return {
        type: ACTION_TOGGLE_WHITE_BOARD,
        bool
    };
}


/**
 * Action to handle toggle video from toolbox's video buttons.
 *
 * @param {boolean} muted - Whether to mute or unmute.
 * @param {boolean} showUI - When set to false will not display any error.
 * @param {boolean} ensureTrack - True if we want to ensure that a new track is
 * created if missing.
 * @returns {Function}
 */
export function handleToggleVideoMuted(muted, showUI, ensureTrack) {
    return (dispatch, getState) => {
        const state = getState();
        const { enabled: audioOnly } = state['features/base/audio-only'];

        sendAnalytics(createToolbarEvent(VIDEO_MUTE, { enable: muted }));
        if (audioOnly) {
            dispatch(setAudioOnly(false));
        }

        dispatch(
            setVideoMuted(
                muted,
                VIDEO_MUTISM_AUTHORITY.USER,
                ensureTrack));

        // FIXME: The old conference logic still relies on this event being
        // emitted.
        typeof APP === 'undefined'
            || APP.conference.muteVideo(muted, showUI);

    };
}

/**
 * Signals a request to set float toolbox hidden state.
 *
 * @param {boolean} floatToolboxHidden - True to hide, false to show.
 * @returns {{
 *     type: FLOAT_TOOLBOX_HIDDEN,
 *     floatToolboxHidden: boolean
 * }}
 */
export function setFloatToolboxHidden(floatToolboxHidden: boolean) {
    return {
        type: FLOAT_TOOLBOX_HIDDEN,
        floatToolboxHidden
    };
}
